module.exports = __webpack_public_path__ + "static/media/GetSetGo.4ea77863.png";